<template>
  <div>
    <el-form ref="formRef" :model="packageForm" :label-width="type == 1?'100px':'180px'">
      <div v-if="type == 1">
        <el-form-item label="ICP备案号：">
          <el-input type="text" v-model="packageForm.icpNumber" placeholder="请输入ICP备案号" style="width:24em;"/>
        </el-form-item>
        <el-form-item label="发布年份：">
          <el-input type="text" v-model="packageForm.publishYear" placeholder="请输入发布年份" style="width:24em;"/>
        </el-form-item>
        <el-form-item label="应用名称：">
          <el-input type="text" v-model="packageForm.appName" placeholder="请输入应用名称" style="width:24em;"/>
        </el-form-item>
      </div>
      <div v-if="type == 2">
        <el-form-item label="开屏广告位id：">
          <el-input type="text" v-model="packageForm.coopenAdid" placeholder="请输入开屏广告位id" style="width:24em;"/>
        </el-form-item>
        <el-form-item label="签到广告位id：">
          <el-input type="text" v-model="packageForm.signinAdid" placeholder="请输入签到广告位id" style="width:24em;"/>
        </el-form-item>
        <el-form-item label="看广告任务广告位id：">
          <el-input type="text" v-model="packageForm.taskAdid" placeholder="请输入看广告任务广告位id" style="width:24em;"/>
        </el-form-item>
        <el-form-item label="简历主页广告位id：">
          <el-input type="text" v-model="packageForm.resumeAdid" placeholder="请输入简历主页广告位id" style="width:24em;"/>
        </el-form-item>
        <el-form-item label="首页banner广告位id：">
          <el-input type="text" v-model="packageForm.homeBannerAdid" placeholder="请输入首页banner广告位id" style="width:24em;"/>
        </el-form-item>
        <el-form-item label="发现页banner广告位id：">
          <el-input type="text" v-model="packageForm.discoveryBannerAdid" placeholder="请输入发现页banner广告位id" style="width:24em;"/>
        </el-form-item>
      </div>
      <div v-if="type == 3">
        <el-form-item label="首页划卡包：">
          <el-radio-group v-model="packageForm.versionState">
            <el-radio :label="1">已列入</el-radio>
            <el-radio :label="0">未列入</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>

    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { updatePackageNameInfo } from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      packageForm: this.value.packageForm,
      idx: this.value.ids,
      type: this.value.type,
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.packageForm.icpNumber && this.type == 1) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入ICP备案号',
          type: 'warning'
        });
        return false
      }
      if(!this.packageForm.publishYear && this.type == 1) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入发布年份',
          type: 'warning'
        });
        return false
      }
      if(!this.packageForm.appName && this.type == 1) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入应用名称',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.packageForm.id?this.packageForm.id:0;
      param['icpNumber'] = this.packageForm.icpNumber;
      param['appName'] = this.packageForm.appName;
      param['publishYear'] = this.packageForm.publishYear;
      param['coopenAdid'] = this.packageForm.coopenAdid;
      param['signinAdid'] = this.packageForm.signinAdid;
      param['taskAdid'] = this.packageForm.taskAdid;
      param['resumeAdid'] = this.packageForm.resumeAdid;
      param['homeBannerAdid'] = this.packageForm.homeBannerAdid;
      param['discoveryBannerAdid'] = this.packageForm.discoveryBannerAdid;
      param['versionState'] = this.packageForm.versionState;
      postFormData(updatePackageNameInfo, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
